<template>
    <div>
        <b-tabs :nav-class="tabsNavClass">
            <b-tab title="Court" :active="(initialTab == 'Court')" v-if="true" v-on:click="tabActivated(court)">
                <filter-ui ref="courtQuoteFilter" :api-base-url="apiBaseUrl" :fields="court.filterFields" relatedTo="quote-court" :filter="court.initialFilter" v-on:change="courtFilterChanged"></filter-ui>
                <ejs-grid id="courtQuoteGrid"
                          ref="courtQuoteGrid"
                          :enableStickyHeader="true"
                          :dataSource="court.gridData"
                          :toolbar="courtToolbar"
                          :allowSorting="true"
                          :sortSettings="court.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="courtGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :excelQueryCellInfo="customiseCell"
                          :rowSelected="courtGridRowSelectionChanged"
                          :rowDeselected="courtGridRowSelectionChanged"
                          :toolbarClick="courtGridToolbarClicked"
                          :created="gridCreated(court)"
                          :headerCellInfo="headerCellInfoEvent"
                          :rowDataBound="rowDataBound"
                          v-if="court.show">
                    <e-columns>
                        <e-column field="quoteNumberDisplayText" headerText="Estimate #" width="120"></e-column>
                        <e-column field="courtRegistryName" headerText="Court/Tribunal/Other"></e-column>
                        <e-column field="matterNumber" headerText="Matter Number"></e-column>
                        <e-column field="matterName" headerText="Matter Name"></e-column>
                        <e-column field="firstSittingDate" headerText="First Sitting Date"></e-column>
                        <e-column field="totalSittingDays" headerText="Total Sitting Days"></e-column>
                        <e-column field="clientName" headerText="Client Name"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="quoteStatusDisplayName" headerText="Status"></e-column>
                        <e-column field="calculatedTotalAmount" headerText="Estimated Amount"></e-column>
                        <e-column field="createdByUserAccountDisplayName" headerText="Created By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="createdDateTimeUTC" :headerText="$t('Entities.Shared.CreatedDateTimeUTC')"></e-column>
                        <e-column field="lastUpdateByUserAccountDisplayName" headerText="Last Updated By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="lastUpdateDateTimeUTC" headerText="Last Updated"></e-column>
                        <e-column field="disabledByUserAccountDisplayName" headerText="Cancelled By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="disabledDateTimeUTC" headerText="Date Cancelled"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>

            <b-tab title="Interview" :active="(initialTab == 'Interview')" v-if="true" v-on:click="tabActivated(interview)">
                <filter-ui ref="interviewQuoteFilter" :api-base-url="apiBaseUrl" :fields="interview.filterFields" relatedTo="quote-interview" :quick-filters="interview.quickFilters" :filter="interview.initialFilter" v-on:change="interviewFilterChanged"></filter-ui>
                <ejs-grid id="interviewQuoteGrid"
                          ref="interviewQuoteGrid"
                          :enableStickyHeader="true"
                          :dataSource="interview.gridData"
                          :toolbar="interviewToolbar"
                          :allowSorting="true"
                          :sortSettings="interview.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="interviewGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :excelQueryCellInfo="customiseCell"
                          :rowSelected="interviewGridRowSelectionChanged"
                          :rowDeselected="interviewGridRowSelectionChanged"
                          :toolbarClick="interviewGridToolbarClicked"
                          :created="gridCreated(interview)"
                          :headerCellInfo="headerCellInfoEvent"
                          :rowDataBound="rowDataBound"
                          v-if="interview.show">
                    <e-columns>
                        <e-column field="quoteNumberDisplayText" headerText="Estimate #" width="120"></e-column>
                        <e-column field="interviewOrganisationName" headerText="Interview Organisation"></e-column>
                        <e-column field="interviewDateTime" headerText="Date/Time of Interview"></e-column>
                        <e-column field="interviewLocation" headerText="Location"></e-column>
                        <e-column field="interviewLengthString" headerText="Interview Length"></e-column>
                        <e-column field="clientName" headerText="Firm/Organisation"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="quoteStatusDisplayName" headerText="Status"></e-column>
                        <e-column field="calculatedTotalAmount" headerText="Estimated Amount"></e-column>
                        <e-column field="createdByUserAccountDisplayName" headerText="Created By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="createdDateTimeUTC" :headerText="$t('Entities.Shared.CreatedDateTimeUTC')"></e-column>
                        <e-column field="lastUpdateByUserAccountDisplayName" headerText="Last Updated By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="lastUpdateDateTimeUTC" headerText="Last Updated"></e-column>
                        <e-column field="disabledByUserAccountDisplayName" headerText="Cancelled By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="disabledDateTimeUTC" headerText="Date Cancelled"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>

            <b-tab title="Quick Estimations" :active="(initialTab == 'Simple')" v-if="true" v-on:click="tabActivated(simple)">
                <filter-ui ref="simpleQuoteFilter" :api-base-url="apiBaseUrl" :fields="simple.filterFields" relatedTo="quote-simple" :quick-filters="simple.quickFilters" :filter="simple.initialFilter" v-on:change="simpleFilterChanged"></filter-ui>
                <ejs-grid id="simpleQuoteGrid"
                          ref="simpleQuoteGrid"
                          :enableStickyHeader="true"
                          :dataSource="simple.gridData"
                          :toolbar="simpleToolbar"
                          :allowSorting="true"
                          :sortSettings="simple.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="simpleGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :excelQueryCellInfo="customiseCell"
                          :rowSelected="simpleGridRowSelectionChanged"
                          :rowDeselected="simpleGridRowSelectionChanged"
                          :toolbarClick="simpleGridToolbarClicked"
                          :created="gridCreated(simple)"
                          :headerCellInfo="headerCellInfoEvent"
                          :rowDataBound="rowDataBound"
                          v-if="simple.show">
                    <e-columns>
                        <e-column field="quoteNumberDisplayText" headerText="Estimate #" width="120"></e-column>
                        <e-column field="courtRegistryName" headerText="Court/Tribunal/Other"></e-column>
                        <e-column field="interviewOrganisationName" headerText="Interview Organisation"></e-column>
                        <e-column field="estimatedDurationDisplayText" headerText="Estimated Duration"></e-column>
                        <e-column field="clientName" headerText="Firm/Organisation"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="calculatedTotalAmount" headerText="Estimated Amount"></e-column>
                        <e-column field="createdByUserAccountDisplayName" headerText="Created By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="createdDateTimeUTC" :headerText="$t('Entities.Shared.CreatedDateTimeUTC')"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
        </b-tabs>

        <validation-observer v-slot="vp" slim>
            <b-modal size="lg"
                     centered
                     no-close-on-backdrop
                     no-close-on-esc
                     v-model="dialogOpen"
                     v-on:ok.prevent="vp.handleSubmit(processQuoteClient)">

                <template #modal-header>
                    <h5 class="modal-title">Select Quote Client</h5>
                </template>

                <b-form-row class="d-flex flex-column align-items-end">
                    <b-table striped hover fixed small :items="currentQuote.clients" :fields="clientFields" class="mb-0">
                        <template #cell(action)="row">
                            <b-form-radio v-model="selectedQuoteClientId" name="selectedQuoteClient" :value="row.item.quoteClientId" v-if="isUuidNullOrEmpty(row.item.orderId)"></b-form-radio>
                        </template>
                    </b-table>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport } from '@syncfusion/ej2-vue-grids';
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';

    import FilterUI from './FilterUI';

    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';
    import UuidMixins from '../../mixins/UuidMixins';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin)
    
    //this is required to make the gealkdshflaksfdhtGroupCaption function available globally and thus within the groupCaptionTemplate
    var quotesGrid_vueComponent = null;
    function quotesGrid_getGroupCaption(field, headerText, value) {
        return quotesGrid_vueComponent.getGroupCaption(field, headerText, value);
    }
    window.quotesGrid_getGroupCaption = quotesGrid_getGroupCaption;

    export default {
        name: 'QuotesGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins, UuidMixins],   
        components: { 
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            pagesBaseUrl: {
                type: String,
                required: true
            },
            canCreateQuotes: {
                type: Boolean,
                default: false
            },
            canCopyQuotes: {
                type: Boolean,
                default: false
            },
            canProcessQuotes: {
                type: Boolean,
                default: false
            },
            allClientOptions: {
                type: Array,
                default: null
            },
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            initialTab: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                groupSettings: { showGroupedColumn: true, disablePageWiseAggregates: true, captionTemplate: "${quotesGrid_getGroupCaption(field, headerText, key)}" },
                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                court: {
                    name: "court",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "CourtRegistryId",
                            label: "Court/Tribunal/Other",
                            type: "multiselect",
                            options: this.allCourtRegistryOptions,
                            placeholder: "Select Court/Tribunal/Other Values"
                        },
                        {
                            field: "FirstSittingDate",
                            label: "First Sitting Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "quoteNumberDisplayText", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "quoteNumberDisplayText", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                interview: {
                    name: "interview",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "InterviewOrganisationId",
                            label: "Interview Organisation",
                            type: "multiselect",
                            options: this.allInterviewOrganisationOptions,
                            placeholder: "Select Interview Organisation Values"
                        },
                        {
                            field: "InterviewDate",
                            label: "Interview Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "quoteNumberDisplayText", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "quoteNumberDisplayText", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                simple: {
                    name: "simple",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "CourtRegistryId",
                            label: "Court/Tribunal/Other",
                            type: "multiselect",
                            options: this.allCourtRegistryOptions,
                            placeholder: "Select Court/Tribunal/Other Values"
                        },
                        {
                            field: "InterviewOrganisationId",
                            label: "Interview Organisation",
                            type: "multiselect",
                            options: this.allInterviewOrganisationOptions,
                            placeholder: "Select Interview Organisation Values"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "quoteNumberDisplayText", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "quoteNumberDisplayText", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                currentQuote: {
                    clients: [],
                },
                currentGrid: null,
                disableQuoteDialogShown: false,
                showErrors: false,
                currentErrors: null,
                disableReason: null,
                currentTab: this.initialTab,

                columnFormats: {
                    firstSittingDate: {
                        type: 'datetime',
                        options: {
                            mode: 'excludetime'
                        }
                    },
                    interviewDateTime: {
                        type: 'datetime',
                        options: {
                            outputAsUTC: true
                        }
                    },
                    calculatedTotalAmount: {
                        type: 'currency'
                    },
                    createdDateTimeUTC: {
                        type: 'datetime'
                    },
                    lastUpdateDateTimeUTC: {
                        type: 'datetime'
                    },
                    disabledDateTimeUTC: {
                        type: 'datetime'
                    },
                },

                dialogOpen: false,

                clientFields: [
                    {
                        key: 'clientName',
                        label: 'Ordering Client',
                        class: 'text-left'
                    },
                    {
                        key: 'clientBranchName',
                        label: "Ordering Client Branch",
                        class: 'text-left'
                    },
                    {
                        key: 'clientContactName',
                        label: "Ordering Client Contact",
                        class: 'text-left'
                    },
                    {
                        key: 'action',
                        label: 'Select',
                        class: 'text-right',
                        thStyle: {
                            width: '15rem'
                        }
                    }
                ],
                selectedQuoteClientId: null,
            }
        },
        computed: {
            tabsNavClass: function () {
                var tabsNavClass = "bquote-bottom-0";
                return tabsNavClass;
            },
            courtToolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems();
                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "Open", tooltipText: "Open selected Estimate Details", prefixIcon: "fas fa-file-alt", id: "quotedetails", cssClass: "quotedetails" },
                        ]
                    );
                if (this.canCopyQuotes) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Copy", tooltipText: "Copy selected Estimate", prefixIcon: "fas fa-copy", id: "copyquote", cssClass: "copyquote" },
                            ]
                        );
                }
                if (this.canProcessQuotes) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Process Estimate as Order", tooltipText: "Process Estimate as Order", prefixIcon: "fas fa-check", id: "processquote" },
                            ]
                        );
                }
                return toolbarItems;
            },
            interviewToolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems();
                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "Open", tooltipText: "Open selected Estimate Details", prefixIcon: "fas fa-file-alt", id: "quotedetails", cssClass: "quotedetails" },
                        ]
                    );
                if (this.canCopyQuotes) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Copy", tooltipText: "Copy selected Estimate", prefixIcon: "fas fa-copy", id: "copyquote", cssClass: "copyquote" },
                            ]
                        );
                }
                if (this.canProcessQuotes) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Process Estimate as Order", tooltipText: "Process Estimate as Order", prefixIcon: "fas fa-check", id: "processquote" },
                            ]
                        );
                }
                return toolbarItems;
            },
            simpleToolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems();
                return toolbarItems;
            }
        },
        methods: {
            getGroupCaption: function (field, headerText, value) {
                return headerText + ": " + value;
            },
            customiseCell: function (args) {
                //console.log(args.data);
                if ((args.column.field == 'quoteNumberDisplayText') && (args.name == 'queryCellInfo') && (args.data.quoteOrderTypeId == null)) {
                    args.cell.innerHTML = "<a href='" + this.$urlHelper.getPageUrl('Estimates', [args.data.quoteId]) + "' target='_blank'>" + args.data.quoteNumberDisplayText + "</a>";                
                } else {
                    this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
                }
            },
            rowDataBound: function (args) {                
                if (args.data.disabledDateTimeUTC) {
                    args.row.classList.add('cancelled');
                }
                else if (args.data.finalizedDateTimeUTC) {
                    if (args.data.orderId) args.row.classList.add('processed');
                    else if (args.data.isPartiallyProcessed) args.row.classList.add('partiallyProcessed');
                    else args.row.classList.add('finalized');
                }
            },
            tabActivated: function (relatedTo) {
                if (!relatedTo.dataLoaded) {
                    relatedTo.grid.refresh();
                    relatedTo.dataLoaded = true;
                }
                this.currentTab = relatedTo.name;
            },
            getActiveTabData: function () {
                if (this.currentTab == "court") return this.court;
                if (this.currentTab == "interview") return this.interview;
                if (this.currentTab == "simple") return this.simple;
                return this.court;
            },

            courtFilterChanged: function (filter) {
                this.filterChanged(this.court, filter);
            },
            courtGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.court, args);
            },
            courtGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.court.grid, args);
            },
            courtGridToolbarClicked: function (args) {
                this.toolbarClicked(this.court, args);
            },

            interviewFilterChanged: function (filter) {
                this.filterChanged(this.interview, filter);
            },
            interviewGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.interview, args);
            },
            interviewGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.interview.grid, args);
            },
            interviewGridToolbarClicked: function (args) {
                this.toolbarClicked(this.interview, args);
            },

            simpleFilterChanged: function (filter) {
                this.filterChanged(this.simple, filter);
            },
            simpleGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.simple, args);
            },
            simpleGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.simple.grid, args);
            },
            simpleGridToolbarClicked: function (args) {
                this.toolbarClicked(this.simple, args);
            },

            filterChanged: function (relatedTo, filter) {
                relatedTo.gridDataState.filter = filter;
                if (relatedTo.initialized) relatedTo.grid.refresh();
            },
            gridDataStateChanged: function (relatedTo, args) {
                relatedTo.gridDataState.search = args.search;
                relatedTo.gridDataState.sorted = args.sorted;
                relatedTo.gridDataState.group = args.group;
                relatedTo.gridDataState.skip = args.skip;
                relatedTo.gridDataState.take = args.take;
                relatedTo.gridDataState.requiresCounts = args.requiresCounts;
                if (relatedTo.initialized) {
                    relatedTo.grid.showSpinner();
                    this.loadQuotes(relatedTo)
                        .then(result => {
                            if (result) {
                                relatedTo.gridData = result;
                            }
                            relatedTo.grid.hideSpinner();
                        });
                }
            },
            rowSelectionChanged: function (grid, args) {
                if (args.name == 'rowSelected') {
                    this.updateToolbarItems(grid, grid.getSelectedRecords()[0])
                } else {
                    this.updateToolbarItems(grid, null)
                }
            },
            updateToolbarItems: function (grid, quote) {
                this.setToolbarItemState(grid, 'quotedetails', (quote != null && this.currentTab != 'simple'));
                if (this.canCopyQuotes) {
                    this.setToolbarItemState(grid, 'copyquote', (quote != null && this.currentTab != 'simple'));
                }
                if (this.canProcessQuotes) {
                    this.setToolbarItemState(grid, 'processquote', (quote != null && quote.canCreateOrder && this.currentTab != 'simple'));
                }
                this.setToolbarItemState(grid, 'quoteactionsseparator', (quote != null));
            },
            setToolbarItemState: function (grid, itemClass, enabled) {
                grid.toolbarModule.enableItems([itemClass], enabled);
            },
            toolbarClicked: function (relatedTo, args) {
                if (args.item.id === 'quotedetails') {
                    this.handleAction(args.item.id, relatedTo.grid.getSelectedRecords()[0]);
                } else if (args.item.id === 'copyquote') {
                    this.handleAction(args.item.id, relatedTo.grid.getSelectedRecords()[0]);
                } else if (args.item.id === 'processquote') {
                    this.handleAction(args.item.id, relatedTo.grid.getSelectedRecords()[0]);
                    this.orderType = relatedTo;
                } else if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...relatedTo.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    relatedTo.grid.showSpinner();
                    this.loadQuotes(relatedTo)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = relatedTo.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                relatedTo.grid.excelExport({ dataSource: groupedData });
                            }
                            relatedTo.grid.hideSpinner();
                        });
                } else if (args.item.id === 'reset') {
                    this.deleteGridSettings(relatedTo.grid)
                        .then(() => {
                            relatedTo.gridDataState.search = "";
                            relatedTo.show = false;
                            Vue.nextTick(() => {
                                relatedTo.show = true;
                                Vue.nextTick(() => {
                                    relatedTo.grid = (relatedTo.name == "court") ? this.$refs.courtQuoteGrid.ej2Instances :
                                        (relatedTo.name == "interview") ? this.$refs.interviewQuoteGrid.ej2Instances : this.$refs.simpleQuoteGrid.ej2Instances;
                                    this.setupGridPersistence(relatedTo.grid);
                                    this.updateToolbarItems(relatedTo.grid, null);
                                    relatedTo.grid.refresh();
                                });
                            });
                        });
                } else {
                    this.defaultEJ2DataGridToolbarClickHandler(args, relatedTo.grid);
                }
            },
            handleAction: function (action, quote) {
                if (quote) {
                    //var quoteDetails = "<div>";
                    //if (quote.quoteRegistry && quote.quoteRegistry.name) quoteDetails += "<p><strong>Quote/Tribunal/Other:</strong>&nbsp;" + quote.quoteRegistry.name + "</p>";
                    //if (quote.quoteMatter && quote.quoteMatter.displayName) quoteDetails += "<p><strong>Matter:</strong>&nbsp;" + quote.quoteMatter.displayName + "</p>";
                    //if (quote.interviewOrganisation && quote.interviewOrganisation.name) quoteDetails += "<p><strong>Organisation:</strong>&nbsp;" + quote.interviewOrganisation.name + "</p>";
                    //if (quote.interview && quote.interview.displayName) quoteDetails += "<p><strong>Interview:</strong>&nbsp;" + quote.interview.displayName + "</p>";
                    //if (quote.quoteingClient && quote.quoteingClient.name) quoteDetails += "<p><strong>Quoteing Client:</strong>&nbsp;" + quote.quoteingClient.name + "</p>";
                    //quoteDetails += "</div>";
                    if (action === 'quotedetails') {
                        window.open(this.$urlHelper.getPageUrl('Estimates', [quote.quoteId]));
                    } else if (action === 'copyquote') {
                        window.open(this.$urlHelper.getPageUrl('Estimates/Copy', [quote.quoteId]));
                    } else if (action === 'processquote') { 
                        this.$bvModal.msgBoxConfirm(
                            [
                                this.$createElement(
                                    'div',
                                    {
                                        domProps:
                                        {
                                            innerHTML: "<p>Are you sure you want to process the estimate as an order?</p>"
                                        }
                                    }
                                )
                            ],
                            {
                                title: 'Process Estimate',
                                size: 'md',
                                okVariant: 'success',
                                okTitle: 'Yes, Process Estimate as Order',
                                cancelTitle: 'No, Do Not Process',
                                centered: true
                            })
                            .then(value => {
                                if (value) {
                                    if (quote.askForOrderClient) {
                                        this.showModal(quote);
                                    }
                                    else {
                                        this.processQuote(quote.quoteId, quote.interviewOrganisationId != null ? "interview" : "court");
                                    }
                                }
                            });
                    }   

                }
            },
            loadQuotes: function (relatedTo) {
                var url = this.apiBaseUrl + '/Quote/list/' + relatedTo.name;
                //console.log(url);
                return axios
                    .post(url, JSON.stringify(relatedTo.gridDataState), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((quote) => {
                                quote.interviewLengthString = this.formatSecondsAsDuration(quote.interviewLengthInSeconds);
                                return quote;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
            gridCreated: function (relatedTo) {
                Vue.nextTick(() => {
                    this.defaultEJ2DataGridCreatedHandler(relatedTo.grid);
                });
            },
            showModal: function (quote) {
                this.currentQuote = quote;
                this.selectedQuoteClientId = null;
                this.dialogOpen = true;
            },
            processQuoteClient: function () {
                if (this.isUuidNullOrEmpty(this.selectedQuoteClientId)) { return; }

                var url = '';
                if (this.currentTab == "Court" || this.currentTab == "court")
                    url = this.$urlHelper.getPageUrl('Orders/ProcessCourtQuote', [this.currentQuote.quoteId, this.selectedQuoteClientId]);
                else if (this.currentTab == "Interview" || this.currentTab == "interview")
                    url = this.$urlHelper.getPageUrl('Orders/ProcessInterviewQuote', [this.currentQuote.quoteId, this.selectedQuoteClientId]);
                console.log(url);
                this.currentOrderRequest = null;
                Vue.nextTick(() => {
                    window.open(url);
                });

                this.dialogOpen = false;
            },
            processQuote: function (quoteId, orderType) {
                var url = '';
                if (orderType == "court")
                    url = this.$urlHelper.getPageUrl('Orders/ProcessCourtQuote', [quoteId, null]);
                else if (orderType == "interview")
                    url = this.$urlHelper.getPageUrl('Orders/ProcessInterviewQuote', [quoteId, null]);

                this.currentOrderRequest = null;
                Vue.nextTick(() => {
                    window.open(url);
                });
            },
        },
        mounted: function () {
            quotesGrid_vueComponent = this;
            this.court.grid = this.$refs.courtQuoteGrid.ej2Instances;
            this.setupGridPersistence(this.court.grid);
            this.updateToolbarItems(this.court.grid, null);
            this.$refs.courtQuoteFilter.loadQuickFilters()
                .then(() => {
                    this.court.initialized = true;
                    if (this.initialTab == 'Court') {
                        setTimeout(() => {
                            this.court.grid.refresh();
                            this.court.dataLoaded = true;
                        }, 250);
                    }
                });
   
            this.interview.grid = this.$refs.interviewQuoteGrid.ej2Instances;
            this.setupGridPersistence(this.interview.grid);
            this.updateToolbarItems(this.interview.grid, null);
            this.$refs.interviewQuoteFilter.loadQuickFilters()
                .then(() => {
                    this.interview.initialized = true;
                    if (this.initialTab == 'Interview') {
                        setTimeout(() => {
                            this.interview.grid.refresh();
                            this.interview.dataLoaded = true;
                        }, 250);
                    }
                });

            this.simple.grid = this.$refs.simpleQuoteGrid.ej2Instances;
            this.setupGridPersistence(this.simple.grid);
            this.updateToolbarItems(this.simple.grid, null);
            this.$refs.simpleQuoteFilter.loadQuickFilters()
                .then(() => {
                    this.simple.initialized = true;
                    if (this.initialTab == 'Simple') {
                        setTimeout(() => {
                            this.simple.grid.refresh();
                            this.simple.dataLoaded = true;
                        }, 250);
                    }
                });
        }
    }
</script>

<style scoped>

    >>> .finalized {
        background-color: #fff2bf !important;
    }

    >>> .processed {
        background-color: #90e780 !important;
    }

    >>> .cancelled {
        background-color: #F5C6CB !important;
    }

    >>> .partiallyProcessed {
        background-color: #ff6a00ff !important;
    }
</style>